
// Country services rest api calling

import { routes } from '../config/api_routes'
import moment from "moment";

export const locationService = {

    // get country 
    // info: sortDesc : Boolean
    
    getCountry: (formData) => window.axios.post(routes.getCountryListApi,formData),

    // get state

    getState: (formData) => window.axios.post(routes.getStateListApi,formData),

    // get city

    getCity: (formData) => window.axios.post(routes.getCityListApi,formData),

    // add country 

    addCountry: (formData) => window.axios.post(routes.addCountryApi,formData),

    // get countryByID 

    getCountryById: (formData) => window.axios.post(routes.getCountryByIdApi,formData),

    // update countryByID

    updateCountryById: (formData) => window.axios.post(routes.updateCountryApi,formData),

    // add State 

    addState: (formData) => window.axios.post(routes.addStateApi,formData),

    // get statebyID 

    getStateById: (formData) => window.axios.post(routes.getStateByIdApi,formData),

    // update stateByID

    updateStateById: (formData) => window.axios.post(routes.updateStateApi,formData),

    // add city 

    addCity: (formData) => window.axios.post(routes.addCityApi,formData),

    // get cityByID

    getCityById: (formData) => window.axios.post(routes.getCityByIdApi,formData),

    // update cityByID 

    updateCityById: (formData) => window.axios.post(routes.updateCityApi,formData),

	getIncentives: (data) => window.axios.get(routes.getIncentivesApi, {params:data}),

	updateIncentive: (formData) => window.axios.post(routes.updateIncentiveApi,formData),

	getDisabledTimeSlotEndTime(time_slots_wise_incentives, date, dayIndex, slotIndex) {
		let timeSlots = time_slots_wise_incentives[dayIndex].time_slots.filter((slot, i) => 
			i !== slotIndex && slot.start_time && slot.end_time
		);

		let isDisabled = timeSlots.some(slot => 
			moment(date, 'hh:mm A').isAfter(moment(slot.start_time, 'hh:mm A')) &&
			moment(date, 'hh:mm A').isSameOrBefore(moment(slot.end_time, 'hh:mm A'))
		);

		let currentSlot = time_slots_wise_incentives[dayIndex].time_slots[slotIndex];

		if (!isDisabled && currentSlot.start_time) {
			let startTime = moment(currentSlot.start_time, 'hh:mm A');

			isDisabled = timeSlots.some(slot => 
				startTime.isSameOrBefore(moment(slot.start_time, 'hh:mm A')) &&
				moment(date, 'hh:mm A').isAfter(moment(slot.start_time, 'hh:mm A'))
			);

			if (!isDisabled && moment(date, 'hh:mm A').isSameOrBefore(startTime)) {
				isDisabled = true;
			}
		}

		return isDisabled;
	},
	getDisabledTimeSlotStartTime(time_slots_wise_incentives, date, dayIndex, slotIndex) {
		let timeSlots = time_slots_wise_incentives[dayIndex].time_slots.filter((slot, i) => 
			i !== slotIndex && slot.start_time && slot.end_time
		);

		let isDisabled = timeSlots.some(slot => 
			moment(date, 'hh:mm A').isSameOrAfter(moment(slot.start_time, 'hh:mm A')) &&
			moment(date, 'hh:mm A').isBefore(moment(slot.end_time, 'hh:mm A'))
		);

		let currentSlot = time_slots_wise_incentives[dayIndex].time_slots[slotIndex];

		console.log(currentSlot, time_slots_wise_incentives, date, dayIndex, slotIndex);
		

		if (!isDisabled && currentSlot.end_time) {
			let endTime = moment(currentSlot.end_time, 'hh:mm A');

			isDisabled = timeSlots.some(slot => 
				endTime.isSameOrAfter(moment(slot.end_time, 'hh:mm A')) &&
				moment(date, 'hh:mm A').isBefore(moment(slot.end_time, 'hh:mm A'))
			);

			if (!isDisabled && moment(date, 'hh:mm A').isSameOrAfter(endTime)) {
				isDisabled = true;
			}
		}

		return isDisabled;
	},
}